import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  { subject }: Boundaries["retrieveDiscussion"]["failure"],
): State {
  return state.map((result) =>
    result.subject === subject
      ? { ...result, request: setRequestStateToFailure() }
      : result,
  );
}

export { handleFailure };
